package org.bsvac.bsvac_kmp.data.models

enum class CrewModel(val displayString: String, val certificationModel: CertificationModel) {
    POINTER_JAMES("POINTER, JAMES", CertificationModel.EMT),
    DELOSANTOS_LEONEL("DELOSANTOS, LEONEL", CertificationModel.EMT),
    ROBINSON_ANTOINE("ROBINSON, ANTOINE", CertificationModel.PARAMEDIC),
    BYAM_MATTHEW("BYAM, MATTHEW", CertificationModel.EMT),
    THOMAS_WARREN("THOMAS, WARREN", CertificationModel.MVO),
    FRAGOSA_ANDREW("FRAGOSA, ANDREW", CertificationModel.EMT),
    CARRANZA_MARIA("CARRANZA, MARIA", CertificationModel.EMT),
    RODRIGUEZ_JESUS("RODRIGUEZ, JESUS", CertificationModel.EMT),
    SEXTON_KATHY("SEXTON, KATHY", CertificationModel.EMT),
    PRICE_JAMES("PRICE, JAMES", CertificationModel.EMT),
    GRAVES_SEAN("GRAVES, SEAN", CertificationModel.EMT);

    companion object {
        fun validEntries(selectedAgency: AgencyModel?): List<CrewModel> {
            return when (selectedAgency) {
                AgencyModel.BSVAC -> listOf(
                    POINTER_JAMES,
                    DELOSANTOS_LEONEL,
                    ROBINSON_ANTOINE,
                    BYAM_MATTHEW,
                    THOMAS_WARREN,
                    FRAGOSA_ANDREW,
                    CARRANZA_MARIA
                )
                AgencyModel.GVEMS -> listOf(
                    RODRIGUEZ_JESUS, SEXTON_KATHY, PRICE_JAMES,
                    GRAVES_SEAN
                )
                null -> emptyList()
            }
        }
    }
}